interface GetEpisodeLabelInput {
    episode_number: Maybe<string>;
    episode: Maybe<string>;
}

export const getEpisodeLabel = ({
    episode_number,
    episode,
}: GetEpisodeLabelInput): Maybe<string> => {
    const hasEpisodeNumber = (episode_number?.length ?? 0) > 0;
    const hasEpisode = (episode?.length ?? 0) > 0;

    if (hasEpisode && hasEpisodeNumber) {
        return `EP ${episode_number}: ${episode}`;
    }

    if (hasEpisode) {
        return episode;
    }

    return null;
};
